import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import "./index.css";

import { App } from "./App";
import { queryClient } from "./lib/queryClient";

document.title = import.meta.env.DEV ? "Dev Vendor Portal" : "SGS Vendor Portal";

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root element in index.html.");
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
);
